import { defineMessages } from 'react-intl';

export const locationSelectorModalMessages = defineMessages({
  'locationSelectorModal:title': {
    id: 'locationSelectorModal:title',
    defaultMessage: 'Set Your Location',
    description: 'Title of the location selector modal dialog.',
  },
  'locationSelectorModal:subtitle': {
    id: 'locationSelectorModal:subtitle',
    defaultMessage: 'And get relevant offers',
    description: 'Subtitle text below the title in the location selector modal.',
  },
  'locationSelectorModal:useCurrentLocation': {
    id: 'locationSelectorModal:useCurrentLocation',
    defaultMessage: 'Use My Current Location',
    description: 'Option to use current device location.',
  },
  'locationSelectorModal:searchAnotherLocation': {
    id: 'locationSelectorModal:searchAnotherLocation',
    defaultMessage: 'Search for another location',
    description: 'Text below the selected city name in the location selector.',
  },
  'locationSelectorModal:searchForLocation': {
    id: 'locationSelectorModal:searchForLocation',
    defaultMessage: 'Search for Location',
    description: 'Option to search for a specific location when no location is selected.',
  },
  'locationSelectorModal:findOffersNearSpecificLocation': {
    id: 'locationSelectorModal:findOffersNearSpecificLocation',
    defaultMessage: 'Find offers near specific location',
    description: 'Subtitle for the search for location option when no location is selected.',
  },
  'locationSelectorModal:showAllOffers': {
    id: 'locationSelectorModal:showAllOffers',
    defaultMessage: 'Show All Offers',
    description: 'Option to show all offers regardless of location.',
  },
  'locationSelectorModal:offersAvailableEverywhere': {
    id: 'locationSelectorModal:offersAvailableEverywhere',
    defaultMessage: "Regardless of where they're available",
    description: 'Subtext for the show all offers option.',
  },
  'locationSelectorModal:cancel': {
    id: 'locationSelectorModal:cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button text in the location selector modal.',
  },
});
